module.exports = __webpack_public_path__ + "static/media/0011.44e99331.png";